import { createMuiTheme } from '@material-ui/core/styles';
import { Background } from '../assets/images';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0047BA',
      light: '#00A0DF',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#FF9E18',
      light: '#FFC107',
    },
    text: {
      primary: '#646464',
      secondary: '#C4C4C4',
    },
    error: {
      main: '#DB0032',
    },
    background: {
      default: '#000',
    },
  },
  typography: {
    fontFamily: '"Noto Sans", sans-serif',
    button: {
      textTransform: 'none'
    }
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
      fullWidth: true,
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          background: `no-repeat center/cover fixed url(${Background})`,
        },
      },
    },
    MuiButton: {
      root: {
        fontWeight: 700,
      },
    },
  },
});

export default theme;
